import {useState, useEffect} from "react";
import {
    Grid,
    Typography,
    Card,
    CardContent,
    Button
} from "@material-ui/core";
import {withRouter, Link} from "react-router-dom";

import Header from "../../components/Header/Header"; 

//notification
import Alert from "../../components/Alert/Alert";

// styles
import useStyles from "./styles";

//lottie
import Lottie from "lottie-react";
import animationData from '../../animations/gift.json'

function StarForm(props) {

    const classes = useStyles();

    // local
    const [notify, setNotify] = useState({isOpen: false, msg:'', type:''});
    const {name, age, sex} = props.location

    //validaciones error
    useEffect(() => {
        setNotify({
            isOpen: true,
            msg: '¡Gracias por patrocinar una sonrisa y compartir esperanza en esta navidad!',
            type: 'success'
        })
    }, []);

    return (
        <>
            <Header />
            <Grid container className={classes.container}>
                <Alert notify={notify} setNotify={setNotify} />
                <Lottie animationData={animationData} className={classes.logotypeContainer} />
                <div className={classes.formContainer}>
                    <div className={classes.form}>
                        <Card className={classes.card}>
                            <CardContent>
                                <div className={classes.formDividerContainer}>
                                    <Typography variant="h2" className={classes.subGreeting}>
                                        ¡Muchas Gracias!
                                    </Typography>
                                </div>

                                <Typography variant="h6" weight="medium" className={classes.message} style={{ marginBottom: "20px" }}>
                                    Tu generosidad hace posible este hermoso proyecto navideño y llena de esperanza a la niñez.
                                </Typography>
                                
                                {/* Cuadro de datos con más espacio y sin arrobas */}
                                <div style={{ backgroundColor: "#f4f6f8", padding: "20px", borderRadius: "8px", margin: "20px 0" }}>
                                    <Typography variant="h6" weight="medium" style={{ marginBottom: "12px" }}>
                                        Patrocinas un regalo para:
                                    </Typography>
                                    <Typography variant="h5" style={{ fontWeight: "bold", margin: "10px 0" }}>
                                        Nombre: {name}
                                    </Typography>
                                    <Typography variant="h5" style={{ fontWeight: "bold", margin: "10px 0" }}>
                                        Edad: {age} años
                                    </Typography>
                                    <Typography variant="h5" style={{ fontWeight: "bold", margin: "10px 0" }}>
                                        Género: {sex === 1 ? 'Niño' : 'Niña'}
                                    </Typography>
                                </div>

                                <Typography variant="h6" weight="medium" className={classes.message} style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    Te enviaremos un correo con la información y te contactaremos de parte de Milagros de Esperanza para coordinar la entrega del regalo.
                                </Typography>

                                <div className={classes.FormButton}>
                                    <Button
                                        size="large"
                                        variant="contained"
                                        fullWidth
                                        color="primary"
                                        className={classes.Button}
                                        component={Link}
                                        to="/"
                                    >
                                        INICIO
                                    </Button>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </Grid>
        </>
    );
}

export default withRouter(StarForm);